module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-pages",
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "id": "pages"
    }
  }, [_c('div', {
    staticClass: "panel__left show_panel gjs-pn-panel gjs-pn-panel-top gjs-one-bg gjs-two-color",
    attrs: {
      "id": "panel__left"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    staticClass: "panel__list-page gjs-pn-panel gjs-pn-panel-basic gjs-one-bg gjs-two-color",
    attrs: {
      "id": "panel__list-page"
    }
  }, [(_vm.$route.name === 'segment') ? _c('custom-segment-panel-pages', {
    attrs: {
      "is-edit-segement": _vm.isEditSegement
    },
    on: {
      "transitionSelected": _vm.addTransition
    }
  }) : _vm._e(), _vm._v(" "), _c('custom-panel-pages', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name !== 'segment'),
      expression: "$route.name !== 'segment'"
    }],
    on: {
      "transitionSelected": _vm.addTransition
    }
  })], 1)]), _vm._v(" "), (_vm.showModal) ? _c('transition-modal', {
    attrs: {
      "slide": _vm.selectedSlideTransition
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbefd18e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/PanelWrapper.vue
// module id = 850
// module chunks = 1 3